export const getParamsToStore = (
  params: URLSearchParams,
  searchParams: string[]
) => {
  const paramsToStore: Record<string, any> = {};
  searchParams.forEach((param) => {
    const value = params.get(param);
    if (value) {
      paramsToStore[param] = value;
      params.delete(param);
    }
  });
  return paramsToStore;
};
